<template>
  <div
    class="p-relative overflow-hidden container"
    :style="{ padding: blockPadding }"
  >
    <icon-container
      v-for="(icon, i) in icons"
      :key="`${_uid}-${i}`"
      :icon="icon.icon"
      :content="icon.text"
      :color="textColor"
    />
  </div>
</template>

<script>
import { withRatio, toPadding } from "@shared/block-ratio"
import IconContainer from "@/components/IconContainer"

export default {
  components: {
    IconContainer
  },

  props: {
    icons: { type: Array, default: () => [] },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 },
    textColor: { type: String, default: "" }
  },

  computed: {
    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    }
  },

  methods: {
    withRatio
  }
}
</script>
